import getLocaleParam from 'Pods/Shared/Utils/getLocaleParam'

import { searchPageStore } from '../index'

const buildGaAttributesById = (gaAttributes = []) => (
  Object.fromEntries(gaAttributes.filter(Boolean).map((attributes) => [String(attributes.itemId), attributes]))
)

const patchAdultFlags = (currentResults, adultFlags) => {
  let changed = false
  const patchedResults = currentResults.map((model) => {
    const freshFlag = adultFlags[model.id]
    const currentFlag = !!model.attributes?.primaryImage?.isAdultContent
    if (freshFlag === undefined || freshFlag === currentFlag) {
      return model
    }
    changed = true
    return {
      ...model,
      attributes: {
        ...model.attributes,
        primaryImage: { ...model.attributes?.primaryImage, isAdultContent: freshFlag },
      },
    }
  })

  return changed ? patchedResults : currentResults
}

// Moderation flags can change after the action/preload caches serialize a result set, so cached
// payloads may carry a stale primaryImage.isAdultContent - a newly restricted thumbnail would stay
// unblurred and clickable until the caches refresh. Mirror legacy ListingPage.jsx's
// fetchTrackingInfo: re-read the uncached adult flags for the visible ids and patch them in place.
// The same response carries the GA item attributes (brand, categories, variant) the preload
// serializer leaves empty; they are kept apart from the results so the cards do not re-render.
export const refreshTrackingInfo = async () => {
  const itemIds = searchPageStore.getState().results.map((model) => model.id).filter(Boolean)
  if (!itemIds.length) {
    return
  }

  const localeParam = getLocaleParam()
  const query = [
    `item_ids=${itemIds.join(',')}`,
    localeParam ? `locale=${localeParam}` : null,
  ].filter(Boolean).join('&')

  try {
    const trackingInfo = await window.fetchJSON(`/listing_page/tracking_info?${query}`)
    const { adult_flags: adultFlags, ga_attributes: gaAttributes } = trackingInfo || {}
    // Re-read after the await: a filter change may have replaced the set mid-flight. Patching by
    // id only touches items the response covers, so a fresher result set is never clobbered.
    const currentResults = searchPageStore.getState().results
    const nextState = {}

    if (adultFlags) {
      const patchedResults = patchAdultFlags(currentResults, adultFlags)
      if (patchedResults !== currentResults) {
        nextState.results = patchedResults
      }
    }

    if (gaAttributes) {
      nextState.gaAttributesById = {
        ...searchPageStore.getState().gaAttributesById,
        ...buildGaAttributesById(gaAttributes),
      }
      // A response for a superseded set must not mark it ready: the newer set's refresh may have
      // landed first, and overwriting its ids would stop the current grid from reporting.
      const requestedIds = itemIds.join(',')
      const currentIds = currentResults.map((model) => model.id).filter(Boolean).join(',')
      if (requestedIds === currentIds) {
        nextState.trackingInfoIds = requestedIds
      }
    }

    if (Object.keys(nextState).length > 0) {
      searchPageStore.setState(nextState)
    }
  } catch (error) {
    // Best-effort: on failure the serialized flags stay, same silent fallback as ListingPage.
  }
}
